import { defineMessage } from 'services/localization';

export const messages = {
    remaining: defineMessage('amount_remaining'),
    extraAmount: defineMessage('extra_extraamounttext_are_allowed'),
    exceededAmount: defineMessage('po_balance_is_exceeded_by_exceededamount'),
    allocatedAmount: defineMessage('allocated_amount_1'),
    notAllocatedAmount: defineMessage('remaining_amount_amount_in_this_bill'),
    insertRemainingAmount: defineMessage('insert_amount'),
    totalOfAllocatedBills: defineMessage('total_of_allocated_bills'),
    matchedBills: defineMessage('matched_bills'),
};
